import { BASE_FIELDVIEW_URL } from '../constants/urls';
import { requestLegendJSON, requestLegendPut } from '../utils/request';
import { queryParam } from '../utils/queryString';
import { getSeasonSpecificMockFile } from '../utils/mocks';

const DEFAULT_METRIC_FLAG = true;

// only used for mockfile determination, do not change otherwise
let hasWebDriverEditedLegend = false;

/**
 * Get layer legend
 * @param {String} username
 * @param {String} fieldUuid
 * @param {Object} dates
 * @param {Number} dates.endDate
 * @param {Number} dates.startDate
 * @param {Number} dates.year
 * @param {String} crop
 * @param {String} layer
 * @param {String} season
 * @return {Promise} Response
 */
export function requestLegend(username, fieldUuid, dates, crop, layer, season, userUuid) {
  const { endDate, startDate, year } = dates;
  let mockFile;

  if (layer === 'applicationrate') {
    const cropName = decodeURI(decodeURI(crop)).replace(' ', '_').toLowerCase();
    mockFile = `legend/${layer}/${cropName}`;

    if (hasWebDriverEditedLegend) {
      mockFile = `legend/${layer}/edited`;
    }
  } else if (hasWebDriverEditedLegend) {
    mockFile = `legend/${layer}/edited`;
  } else {
    mockFile = getSeasonSpecificMockFile(`legend/${layer}`, season);
  }

  const lastUrlPart = `${layer}/${DEFAULT_METRIC_FLAG}?startTime=${startDate}&endTime=${endDate}`;

  const firstPartUrl = `legend/v3/${userUuid}/${fieldUuid}/${year}/${crop}/`;

  const url = firstPartUrl + lastUrlPart;

  return requestLegendJSON(url,
    {
      rootUrl: `${BASE_FIELDVIEW_URL}/`,
      mockFile,
    }
  );
}

/**
 * Update legend values
 * @param {String} username
 * @param {String} fieldUuid
 * @param {String} crop
 * @param {String} layer
 * @param {Object} legendValues
 * @return {Promise} response
 */
export function putLegend(username, fieldUuid, crop, layer, legendValues) {
  if (queryParam('mocks')) {
    hasWebDriverEditedLegend = true;
  }
  return requestLegendPut('legend/', {
    rootUrl: `${BASE_FIELDVIEW_URL}/`,
    mockFile: `legend/${layer}/edited`,
    data: {
      cloudUUID: fieldUuid,
      crop: decodeURIComponent(decodeURIComponent(crop)),
      legendUnit: legendValues.unit,
      mapType: layer,
      maxValue: legendValues.max,
      metric: DEFAULT_METRIC_FLAG,
      minValue: legendValues.min,
      steps: legendValues.steps,
      username,
    },
  });
}
